import { LayoutGroup } from "framer-motion";
import { Outlet } from "react-router-dom";
import clsx from "clsx";
import Sidebar from "@/features/Navigation/components/Sidebar";
import { MobileSidebarV2 } from "@/features/Navigation/components/MobileSidebar";
import { RightSidebar } from "@/features/Navigation/components/RightSidebar";
import { rightDrawerOpenAtom } from "@/features/Navigation/state";
import { useAtom } from "jotai";
import { MobileRightDrawer } from "@/features/Navigation/components/MobileRightDrawer";

export function AdminLayout() {
    const [rightDrawerOpen] = useAtom(rightDrawerOpenAtom);

    return (
        <LayoutGroup>
            <div
                className={clsx(
                    "min-h-screen w-full px-6 pb-4 pt-5",
                    "flex",
                    rightDrawerOpen ? "justify-between" : "justify-start",
                )}
            >
                <div className="lg:hidden">
                    <MobileSidebarV2
                        parentSections={["Companies", "Deals", "Credit Boxes"]}
                    />
                </div>
                <div className="lg:hidden">
                    <MobileRightDrawer />
                </div>

                <div className="hidden lg:block">
                    <Sidebar
                        parentSections={["Companies", "Deals", "Credit Boxes"]}
                    />
                </div>

                <div
                    className={clsx("flex flex-1 items-center justify-center")}
                >
                    <Outlet />
                </div>
                <div className="hidden lg:block">
                    <RightSidebar />
                </div>
            </div>
        </LayoutGroup>
    );
}
